(function() {
  if (!window.location.pathname.startsWith('/products/')) return;

  var style = document.createElement('style');
  style.textContent = [
    '.product-form__primary-buttons--with-quantity {',
    '  align-items: flex-end !important;',
    '  gap: 12px !important;',
    '}',
    '.product-form__primary-buttons--with-quantity .product-form__quantity .quantity__label {',
    '  margin-bottom: 4px !important;',
    '}',
    '.product-form__primary-buttons--with-quantity .product-form__submit {',
    '  align-self: stretch !important;',
    '  margin-bottom: 0 !important;',
    '}'
  ].join('\n');
  document.head.appendChild(style);
})();
